(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 990px)';
  var MIN_SECTION_PX = 72;
  var DRAG_THRESHOLD_PX = 4;
  var SKIP_SELECTORS = [
    '[data-moje-scroll-spy-skip]',
    '[data-moje-planeta]',
    '#star-background-canvas',
    '[data-moje-roj-root]',
    '[data-moje-loading-section]',
    '.space-objects-abs-container'
  ];
  var LABEL_RULES = [
    { re: /laser/i, label: 'Úvod', icon: 'rocket_launch' },
    { re: /s2b/i, label: 'Planeta', icon: 'planet' },
    { re: /s2/i, label: 'Sekvence', icon: 'movie' },
    { re: /info/i, label: 'Specifikace', icon: 'info' },
    { re: /flight-plan|_plan_|letov/i, label: 'Spolupráce', icon: 'map' },
    { re: /paticka|footer/i, label: 'Kontakt', icon: 'mail' }
  ];

  var root;
  var rail;
  var track;
  var nodesWrap;
  var desktopMq;
  var sections = [];
  var maxScrollY = 0;
  var ticking = false;
  var dragging = false;
  var dragMoved = false;
  var dragStartY = 0;
  var suppressClick = false;
  var nodeJumpY = null;
  var pauseStartY = 0;
  var pauseEndY = 0;
  var sequenceStartY = 0;
  var sequenceEndY = 0;
  var reduceMotion = false;
  var rebuildTimer = 0;
  var renderedSignature = '';
  var revealTimer = 0;
  var revealArmed = false;
  var noAnimTimer = 0;
  /* Po odhalení stránky počkat, než se usadí layout (výška s2b sekce, fonty) – až pak fade-in. */
  var REVEAL_SETTLE_MS = 450;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function prefersReducedMotion() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (err) {
      return false;
    }
  }

  function isDesktop() {
    if (desktopMq) return desktopMq.matches;
    return window.innerWidth >= 990;
  }

  function scrollYNow() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function viewportH() {
    var se = document.scrollingElement || document.documentElement;
    return se.clientHeight || window.innerHeight || 0;
  }

  function layoutBottom(el) {
    if (!el) return 0;
    var rect = el.getBoundingClientRect();
    return rect.bottom + scrollYNow();
  }

  function measureContentEndY() {
    var end = 0;
    var main = document.getElementById('MainContent');
    var i;
    var child;
    var footer;
    if (main) {
      for (i = 0; i < main.children.length; i += 1) {
        child = main.children[i];
        if (child.nodeType !== 1) continue;
        if (child.getBoundingClientRect().height < 8) continue;
        end = Math.max(end, layoutBottom(child));
      }
    }
    footer = document.querySelector('.shopify-section-group-footer-group');
    if (footer && footer.getBoundingClientRect().height >= 8) {
      end = Math.max(end, layoutBottom(footer));
    }
    return end;
  }

  function measureMaxScroll() {
    var vh = viewportH();
    var se = document.scrollingElement || document.documentElement;
    var byDoc = Math.max(0, (se.scrollHeight || 0) - vh);
    var byContent = Math.max(0, measureContentEndY() - vh);
    if (byContent <= 0) return byDoc;
    if (byDoc <= 0) return byContent;
    if (byDoc > byContent + 24) return byContent;
    return byDoc;
  }

  function pageY(el) {
    var rect = el.getBoundingClientRect();
    return rect.top + scrollYNow();
  }

  function sectionAnchorY(el) {
    var s2b;
    var range;
    if (el && el.querySelector) {
      s2b = el.querySelector('.moje-s2b, [id^="moje-s2b-"]');
      if (s2b && typeof window.__mojeS2bSequenceRangeY === 'function') {
        try {
          range = window.__mojeS2bSequenceRangeY();
          if (range && isFinite(range.start) && range.start > 8) return range.start;
        } catch (errS2b) {}
      }
    }
    var anchor = el.querySelector('[data-moje-scroll-spy-anchor]');
    if (anchor) return pageY(anchor);
    return pageY(el);
  }

  function isSectionRoot(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList.contains('shopify-section')) return true;
    return el.id ? el.id.indexOf('shopify-section-') === 0 : false;
  }

  function shouldSkip(el) {
    var i;
    if (!el) return true;
    for (i = 0; i < SKIP_SELECTORS.length; i += 1) {
      if (el.querySelector(SKIP_SELECTORS[i])) return true;
    }
    if (el.hasAttribute('data-moje-scroll-spy-skip')) return true;
    return false;
  }

  function isRenderableSection(el) {
    var style;
    var height;
    if (!isSectionRoot(el) || shouldSkip(el)) return false;
    style = window.getComputedStyle(el);
    if (!style) return false;
    if (style.display === 'none' || style.display === 'contents' || style.visibility === 'hidden') {
      return false;
    }
    height = el.getBoundingClientRect().height;
    return height >= MIN_SECTION_PX;
  }

  function sectionSignature(el) {
    var heading = el.querySelector('h1, h2, h3');
    var headingText = heading && heading.textContent ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
    return (el.id || '') + ' ' + (el.className || '') + ' ' + headingText;
  }

  function escapeLabel(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function metaFor(el) {
    var signature = sectionSignature(el);
    var heading = el.querySelector('h1, h2');
    var text;
    var i;
    for (i = 0; i < LABEL_RULES.length; i += 1) {
      if (LABEL_RULES[i].re.test(signature)) {
        return { label: LABEL_RULES[i].label, icon: LABEL_RULES[i].icon };
      }
    }
    if (heading && heading.textContent) {
      text = heading.textContent.replace(/\s+/g, ' ').trim();
      if (text) return { label: text.slice(0, 28), icon: 'radio_button_checked' };
    }
    return { label: 'Sekce', icon: 'radio_button_checked' };
  }

  function iconName(name) {
    var clean = String(name || '').toLowerCase().replace(/[^a-z0-9_]/g, '');
    return clean || 'radio_button_checked';
  }

  function readPricingY(fn) {
    var y;
    if (typeof fn !== 'function') return 0;
    try {
      y = Number(fn());
    } catch (err) {
      return 0;
    }
    if (!isFinite(y) || y <= 0) return 0;
    return y;
  }

  function collectPricingWaypoints() {
    var points = [];
    var y;
    var i;
    var prev;
    y = readPricingY(window.__mojeS2bPricingScrollY);
    if (y > 0) points.push({ y: y, label: 'Ceník', kind: 'pricing', icon: 'payments' });
    points.sort(function (a, b) {
      return a.y - b.y;
    });
    prev = null;
    for (i = points.length - 1; i >= 0; i -= 1) {
      if (prev && Math.abs(prev.y - points[i].y) < 120) points.splice(i, 1);
      else prev = points[i];
    }
    return points;
  }

  function collectSections() {
    var main = document.getElementById('MainContent');
    var found = [];
    var children;
    var i;
    var y;
    var pricing;
    var meta;
    if (!main) return found;
    children = main.children;
    for (i = 0; i < children.length; i += 1) {
      if (!isRenderableSection(children[i])) continue;
      y = sectionAnchorY(children[i]);
      meta = metaFor(children[i]);
      found.push({
        el: children[i],
        y: y,
        label: meta.label,
        icon: meta.icon,
        kind: 'section'
      });
    }
    pricing = collectPricingWaypoints();
    for (i = 0; i < pricing.length; i += 1) found.push(pricing[i]);
    found.sort(function (a, b) {
      return a.y - b.y;
    });
    return found;
  }

  function introLocked() {
    return !!(document.body && document.body.classList.contains('intro-locked'));
  }

  function loadingActive() {
    var node = document.querySelector('.moje-loading-root');
    if (!node) return false;
    if (node.classList.contains('moje-loading--done') || node.classList.contains('moje-loading--disabled')) {
      return false;
    }
    return true;
  }

  function chromeSpyInert() {
    var html = document.documentElement;
    if (!html) return false;
    return html.classList.contains('moje-s2b-chrome-lock--spy-inert') ||
      html.classList.contains('moje-s2b-chrome-lock--hide-spy') ||
      html.classList.contains('moje-s2b-terraform-lock');
  }

  function wantsS2bIntroAutoplay() {
    try {
      if (typeof window.__mojeS2bWantsIntroAutoplay === 'function') {
        return !!window.__mojeS2bWantsIntroAutoplay();
      }
      if (window.__mojeS2bScrollApi && typeof window.__mojeS2bScrollApi.wantsIntroAutoplay === 'function') {
        return !!window.__mojeS2bScrollApi.wantsIntroAutoplay();
      }
    } catch (errWant) {}
    return false;
  }

  function s2bIntroRange() {
    var seq = readSequenceRange();
    var pause = readPauseRange();
    var start = seq.start;
    var end = seq.end;
    var pricing = readPricingY(window.__mojeS2bPricingScrollY);
    if (pause.start > 8 && (start <= 8 || pause.start < start)) start = pause.start;
    if (pause.end > end) end = pause.end;
    if (pricing > end) end = pricing;
    return { start: start, end: end };
  }

  function isS2bIntroTarget(y) {
    var range = s2bIntroRange();
    if (!(range.start > 8) || !Number.isFinite(y)) return false;
    return y >= range.start - 48 && y <= range.end + 64;
  }

  function redirectS2bIntroTarget(y, opts) {
    var range;
    opts = opts || {};
    if (opts.playAutoplay) return { y: y, opts: opts };
    if (!wantsS2bIntroAutoplay() || !isS2bIntroTarget(y)) return { y: y, opts: opts };
    range = s2bIntroRange();
    return {
      y: range.start,
      opts: Object.assign({}, opts, { playAutoplay: true, source: opts.source || 'scroll-spy-s2b' })
    };
  }

  /*
   * Hero (Moje-laser-video) drží boot overlay; dokud neodhalí stránku, spy se nesmí objevit.
   * Bez hero sekce (jiná šablona) se považuje za odhalené hned.
   */
  var heroRevealFailsafe = false;
  function heroRevealed() {
    if (window.__mojeLaserHeroReady === true || heroRevealFailsafe) return true;
    return !document.querySelector('.intro-sequence-overlay');
  }

  function canShow() {
    return isDesktop() && heroRevealed() && !introLocked() && !loadingActive() && sections.length >= 2 && maxScrollY > 0;
  }

  function readPauseRange() {
    var range = { start: 0, end: 0 };
    var raw;
    if (typeof window.__mojeS2bPauseRangeY !== 'function') return range;
    try {
      raw = window.__mojeS2bPauseRangeY();
    } catch (err) {
      return range;
    }
    if (!raw) return range;
    if (!isFinite(raw.start) || !isFinite(raw.end)) return range;
    if (raw.end <= raw.start + 8) return range;
    range.start = raw.start;
    range.end = raw.end;
    return range;
  }

  function applyPauseZone() {
    var a = 0;
    var b = 0;
    var has = pauseEndY > pauseStartY + 8 && maxScrollY > 0;
    if (!root) return;
    if (has) {
      a = clamp(pauseStartY / maxScrollY, 0, 1);
      b = clamp(pauseEndY / maxScrollY, 0, 1);
    }
    root.style.setProperty('--spy-pause-a', String(a));
    root.style.setProperty('--spy-pause-b', String(b));
    root.style.setProperty('--spy-pause-fill-h', '0');
    root.classList.toggle('has-pause-zone', has && b > a + 0.002);
  }

  function isInPause(currentY) {
    return pauseEndY > pauseStartY + 8 &&
      currentY >= pauseStartY - 4 &&
      currentY < pauseEndY - 0.5;
  }

  function pricingIndexForPause() {
    var i;
    var best = -1;
    var bestDist = Infinity;
    var dist;
    for (i = 0; i < sections.length; i += 1) {
      if (sections[i].kind !== 'pricing') continue;
      dist = Math.abs(sections[i].y - pauseEndY);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function progressNow() {
    if (maxScrollY <= 0) return 0;
    return clamp(scrollYNow() / maxScrollY, 0, 1);
  }

  function setProgress(progress) {
    var pct = Math.round(progress * 100);
    var a;
    var b;
    var fillH = 0;
    if (!root) return;
    root.style.setProperty('--spy-p', String(progress));
    if (maxScrollY > 0 && pauseEndY > pauseStartY + 8) {
      a = clamp(pauseStartY / maxScrollY, 0, 1);
      b = clamp(pauseEndY / maxScrollY, 0, 1);
      if (progress > a && b > a) fillH = Math.min(progress, b) - a;
    }
    root.style.setProperty('--spy-pause-fill-h', String(Math.max(0, fillH)));
    if (track) {
      track.setAttribute('aria-valuenow', String(pct));
      track.setAttribute('aria-valuetext', pct + ' %');
    }
  }

  function setActiveNode(progress) {
    var currentY = progress * maxScrollY;
    var i;
    var buttons;
    var reached;
    var currentIndex = -1;
    var pauseNow = isInPause(currentY);
    var pricingIndex;
    if (!nodesWrap) return;
    for (i = 0; i < sections.length; i += 1) {
      if (sections[i].y <= currentY + 8) currentIndex = i;
    }
    if (pauseNow) {
      pricingIndex = pricingIndexForPause();
      if (pricingIndex >= 0) currentIndex = pricingIndex;
    }
    if (root) root.classList.toggle('is-in-pause', pauseNow);
    buttons = nodesWrap.querySelectorAll('.moje-scroll-spy__node');
    for (i = 0; i < buttons.length; i += 1) {
      reached = i <= currentIndex;
      buttons[i].classList.toggle('is-reached', reached);
      buttons[i].classList.toggle('is-active', i === currentIndex);
    }
  }

  function spacedPercents(raw) {
    var pcts = raw.slice();
    var minGap = pcts.length > 1 ? Math.min(8.5, 70 / pcts.length) : 0;
    var i;
    for (i = 1; i < pcts.length; i += 1) {
      if (pcts[i] < pcts[i - 1] + minGap) pcts[i] = pcts[i - 1] + minGap;
    }
    if (pcts.length && pcts[pcts.length - 1] > 100) {
      var overflow = pcts[pcts.length - 1] - 100;
      for (i = 0; i < pcts.length; i += 1) pcts[i] = Math.max(0, pcts[i] - overflow);
      pcts[pcts.length - 1] = 100;
      for (i = pcts.length - 1; i > 0; i -= 1) {
        if (pcts[i] - pcts[i - 1] < minGap) pcts[i - 1] = Math.max(0, pcts[i] - minGap);
      }
    }
    return pcts;
  }

  function nodesSignature() {
    var parts = [];
    var i;
    for (i = 0; i < sections.length; i += 1) {
      parts.push(sections[i].kind + '|' + sections[i].label + '|' + iconName(sections[i].icon));
    }
    return parts.join('~');
  }

  /* Jednorázově vypnout transitions uzlů (přestavba DOM nesmí „přejet“ z výchozího stavu do aktivního). */
  function suppressNodeAnimations() {
    if (!root) return;
    root.classList.add('is-no-anim');
    window.clearTimeout(noAnimTimer);
    noAnimTimer = window.setTimeout(function () {
      window.requestAnimationFrame(function () {
        if (root) root.classList.remove('is-no-anim');
      });
    }, 40);
  }

  /*
   * Idempotentní render: pokud se sada uzlů (počet / druh / popisky) nezměnila, jen se posunou
   * existující tlačítka (top + data-spy-y). DOM se přestavuje výhradně při změně sady – a to
   * bez transitions, aby aktivní ikona neproblikla. Dřív každý rebuild (load, timery, ResizeObserver
   * na body) přepsal innerHTML a horní ikona pokaždé přejela z výchozího do aktivního stavu.
   */
  function renderNodes() {
    var html = '';
    var i;
    var topPct;
    var label;
    var kindClass;
    var rawPcts = [];
    var pcts;
    var signature;
    var buttons;
    if (!nodesWrap) return;
    for (i = 0; i < sections.length; i += 1) {
      rawPcts.push(maxScrollY > 0 ? clamp((sections[i].y / maxScrollY) * 100, 0, 100) : 0);
    }
    pcts = spacedPercents(rawPcts);
    signature = nodesSignature();
    if (signature === renderedSignature) {
      buttons = nodesWrap.querySelectorAll('.moje-scroll-spy__node');
      if (buttons.length === sections.length) {
        for (i = 0; i < buttons.length; i += 1) {
          topPct = pcts[i].toFixed(3) + '%';
          if (buttons[i].style.top !== topPct) buttons[i].style.top = topPct;
          buttons[i].setAttribute('data-spy-y', String(sections[i].y));
        }
        return;
      }
    }
    for (i = 0; i < sections.length; i += 1) {
      topPct = pcts[i].toFixed(3);
      label = escapeLabel(sections[i].label);
      kindClass = sections[i].kind === 'pricing' ? ' moje-scroll-spy__node--pricing' : '';
      html +=
        '<button type="button" class="moje-scroll-spy__node' +
        kindClass +
        '" style="top:' +
        topPct +
        '%" data-spy-y="' +
        sections[i].y +
        '" aria-label="' +
        label +
        '">' +
        '<span class="moje-scroll-spy__node-mark" aria-hidden="true">' +
        '<span class="moje-scroll-spy__node-icon material-symbols-outlined">' +
        iconName(sections[i].icon) +
        '</span>' +
        '</span>' +
        '<span class="moje-scroll-spy__label">' +
        label +
        '</span>' +
        '</button>';
    }
    if (root && !root.hidden) suppressNodeAnimations();
    nodesWrap.innerHTML = html;
    renderedSignature = signature;
  }

  /*
   * Zobrazení: hidden (display:none) sundat první, .is-ready až v dalším frame – jinak neproběhne
   * fade-in a lišta „vyskočí“. Po odhalení stránky navíc krátká prodleva, než se usadí layout.
   * Skrytí (mobil / intro lock / loading) je okamžité.
   */
  function updateVisibility() {
    var show;
    if (!root) return;
    show = canShow();
    if (!show) {
      window.clearTimeout(revealTimer);
      revealTimer = 0;
      revealArmed = false;
      root.classList.remove('is-ready');
      root.hidden = true;
      return;
    }
    if (root.classList.contains('is-ready')) return;
    if (revealArmed) return;
    revealArmed = true;
    revealTimer = window.setTimeout(function () {
      revealTimer = 0;
      if (!canShow()) {
        revealArmed = false;
        updateVisibility();
        return;
      }
      /* Čerstvé rozměry těsně před zobrazením (revealArmed drží, ať rebuild → update nezacyklí). */
      rebuild();
      root.classList.add('is-no-anim');
      root.hidden = false;
      /* Reflow s opacity 0, pak .is-ready → transition opacity 0 → 1 skutečně proběhne. */
      void root.offsetWidth;
      window.requestAnimationFrame(function () {
        revealArmed = false;
        if (!root) return;
        root.classList.remove('is-no-anim');
        if (!canShow()) {
          updateVisibility();
          return;
        }
        root.classList.add('is-ready');
      });
    }, REVEAL_SETTLE_MS);
  }

  function update() {
    var progress = progressNow();
    setProgress(progress);
    setActiveNode(progress);
    updateVisibility();
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  function readSequenceRange() {
    var range = { start: 0, end: 0 };
    var raw;
    if (typeof window.__mojeS2bSequenceRangeY !== 'function') return range;
    try {
      raw = window.__mojeS2bSequenceRangeY();
    } catch (err) {
      return range;
    }
    if (!raw) return range;
    if (!isFinite(raw.start) || !isFinite(raw.end)) return range;
    if (raw.end <= raw.start + 8) return range;
    range.start = raw.start;
    range.end = raw.end;
    return range;
  }

  function isSequenceY(y) {
    if (!(sequenceEndY > sequenceStartY + 8)) return false;
    return y >= sequenceStartY - 4 && y < sequenceEndY;
  }

  function scrollToY(y, smooth, opts) {
    var top = clamp(y, 0, maxScrollY);
    var useSmooth = smooth && !reduceMotion && !dragging;
    opts = opts || {};
    try {
      document.dispatchEvent(
        new CustomEvent('moje:programmatic-scroll', {
          detail: {
            y: top,
            source: opts.source || 'scroll-spy',
            smooth: useSmooth,
            playAutoplay: !!opts.playAutoplay
          }
        })
      );
    } catch (err) {}
    if (!useSmooth) document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo({
      top: top,
      behavior: useSmooth ? 'smooth' : 'auto'
    });
    if (!useSmooth) {
      window.requestAnimationFrame(function () {
        document.documentElement.style.scrollBehavior = '';
      });
    }
  }

  function ratioFromEvent(event) {
    var rect;
    var point;
    if (!rail) return 0;
    rect = rail.getBoundingClientRect();
    if (rect.height <= 0) return 0;
    point = clientPoint(event);
    return clamp((point.y - rect.top) / rect.height, 0, 1);
  }

  function syncFooterDock() {
    var bar;
    var height;
    if (!root) return;
    bar = document.querySelector('[data-footer-bottom-bar]');
    height = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    if (height < 48) height = 128;
    root.style.setProperty('--footer-bar-h', height + 'px');
  }

  function rebuild() {
    if (!isDesktop()) {
      sections = [];
      maxScrollY = 0;
      pauseStartY = 0;
      pauseEndY = 0;
      sequenceStartY = 0;
      sequenceEndY = 0;
      if (root) {
        root.classList.remove('has-pause-zone', 'is-in-pause');
      }
      updateVisibility();
      return;
    }
    syncFooterDock();
    maxScrollY = measureMaxScroll();
    sections = collectSections();
    pauseStartY = 0;
    pauseEndY = 0;
    sequenceStartY = 0;
    sequenceEndY = 0;
    var pause = readPauseRange();
    pauseStartY = pause.start;
    pauseEndY = pause.end;
    var seq = readSequenceRange();
    sequenceStartY = seq.start;
    sequenceEndY = seq.end;
    applyPauseZone();
    renderNodes();
    update();
  }

  function scheduleRebuild() {
    if (dragging || nodeJumpY != null) {
      window.clearTimeout(rebuildTimer);
      rebuildTimer = window.setTimeout(scheduleRebuild, 140);
      return;
    }
    window.clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuild, 80);
  }

  function nodeFromEvent(event) {
    return event.target && event.target.closest ? event.target.closest('.moje-scroll-spy__node') : null;
  }

  function isAudioControl(event) {
    return !!(event.target && event.target.closest &&
      event.target.closest('[data-moje-scroll-spy-audio], [data-plasma-audio-widget]'));
  }

  function goToY(y, smooth, opts) {
    var redirected;
    if (isNaN(y)) return;
    if (chromeSpyInert()) return;
    redirected = redirectS2bIntroTarget(y, opts);
    scrollToY(redirected.y, smooth, redirected.opts);
  }

  function clientPoint(event) {
    if (event && typeof event.clientY === 'number') {
      return { x: event.clientX, y: event.clientY };
    }
    var t = event && event.changedTouches && event.changedTouches[0];
    if (t) return { x: t.clientX, y: t.clientY };
    return { x: 0, y: 0 };
  }

  function onPointerDown(event) {
    var node;
    var y;
    var point;
    if (!rail) return;
    if (isAudioControl(event)) return;
    if (chromeSpyInert()) {
      if (event.cancelable) event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (typeof event.button === 'number' && event.button !== 0 && !event.changedTouches) return;
    node = nodeFromEvent(event);
    if (node) {
      y = parseFloat(node.getAttribute('data-spy-y'));
      nodeJumpY = isNaN(y) ? null : y;
      suppressClick = true;
      if (event.cancelable) event.preventDefault();
      event.stopPropagation();
      if (nodeJumpY != null) goToY(nodeJumpY, true);
      window.setTimeout(function () {
        if (nodeJumpY != null) nodeJumpY = null;
      }, 400);
      return;
    }
    nodeJumpY = null;
    dragging = true;
    dragMoved = false;
    point = clientPoint(event);
    dragStartY = point.y;
    if (event.pointerId != null && typeof rail.setPointerCapture === 'function') {
      try {
        rail.setPointerCapture(event.pointerId);
      } catch (err) {}
    }
    if (event.cancelable) event.preventDefault();
  }

  function onPointerMove(event) {
    var point;
    if (!dragging) return;
    if (chromeSpyInert()) {
      dragging = false;
      dragMoved = false;
      return;
    }
    point = clientPoint(event);
    if (Math.abs(point.y - dragStartY) < DRAG_THRESHOLD_PX) return;
    dragMoved = true;
    if (event.cancelable) event.preventDefault();
    var nextY = ratioFromEvent(event) * maxScrollY;
    if (wantsS2bIntroAutoplay() && isS2bIntroTarget(nextY)) return;
    scrollToY(nextY, false);
  }

  function onPointerUp(event) {
    if (isAudioControl(event)) return;
    if (chromeSpyInert()) {
      dragging = false;
      dragMoved = false;
      nodeJumpY = null;
      suppressClick = true;
      if (event.cancelable) event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (nodeJumpY != null) {
      nodeJumpY = null;
      dragging = false;
      dragMoved = false;
      suppressClick = true;
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (!dragging) return;
    dragging = false;
    suppressClick = true;
    if (!dragMoved) {
      goToY(ratioFromEvent(event) * maxScrollY, true);
    } else {
      goToY(ratioFromEvent(event) * maxScrollY, false);
    }
    dragMoved = false;
  }

  function onRailClick(event) {
    var node;
    var y;
    if (isAudioControl(event)) return;
    if (chromeSpyInert()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (suppressClick) {
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    node = nodeFromEvent(event);
    if (!node) return;
    event.preventDefault();
    event.stopPropagation();
    y = parseFloat(node.getAttribute('data-spy-y'));
    if (!isNaN(y)) goToY(y, true);
  }

  function onTrackKey(event) {
    var step = Math.max(48, Math.round(maxScrollY * 0.08));
    if (chromeSpyInert()) {
      event.preventDefault();
      return;
    }
    if (event.key === 'ArrowDown' || event.key === 'PageDown') {
      event.preventDefault();
      scrollToY(scrollYNow() + step, true);
    } else if (event.key === 'ArrowUp' || event.key === 'PageUp') {
      event.preventDefault();
      scrollToY(scrollYNow() - step, true);
    } else if (event.key === 'Home') {
      event.preventDefault();
      scrollToY(0, true);
    } else if (event.key === 'End') {
      event.preventDefault();
      scrollToY(maxScrollY, true);
    }
  }

  function bind() {
    var hasPointerEvents = typeof window.PointerEvent === 'function';
    if (!rail || !track) return;
    if (hasPointerEvents) {
      rail.addEventListener('pointerdown', onPointerDown, true);
      rail.addEventListener('pointermove', onPointerMove);
      rail.addEventListener('pointerup', onPointerUp, true);
      rail.addEventListener('pointercancel', onPointerUp, true);
    } else {
      rail.addEventListener('touchstart', onPointerDown, true);
      rail.addEventListener('touchmove', onPointerMove, true);
      rail.addEventListener('touchend', onPointerUp, true);
      rail.addEventListener('touchcancel', onPointerUp, true);
    }
    rail.addEventListener('click', onRailClick, true);
    track.addEventListener('keydown', onTrackKey);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', scheduleRebuild);
    window.addEventListener('load', scheduleRebuild);
    document.addEventListener('moje:page-reveal', scheduleRebuild);
    /* Hero odhalilo stránku → teprve teď má smysl spy ukázat (s prodlevou na usazení layoutu). */
    document.addEventListener('moje:laser-intro-finished', scheduleRebuild);
    window.setTimeout(function () {
      heroRevealFailsafe = true;
      scheduleRebuild();
    }, 12000);
    document.addEventListener('shopify:section:load', scheduleRebuild);
    document.addEventListener('shopify:section:reorder', scheduleRebuild);
    document.addEventListener('shopify:section:unload', scheduleRebuild);
    if (desktopMq && desktopMq.addEventListener) {
      desktopMq.addEventListener('change', scheduleRebuild);
    }
    if (typeof ResizeObserver === 'function' && document.body) {
      new ResizeObserver(scheduleRebuild).observe(document.body);
    }
    if (typeof MutationObserver === 'function' && document.body) {
      new MutationObserver(requestUpdate).observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function boot() {
    root = document.getElementById('moje-scroll-spy');
    if (!root || root.dataset.mojeScrollSpyInit === '1') return;
    root.dataset.mojeScrollSpyInit = '1';
    rail = root.querySelector('[data-moje-scroll-spy-rail]');
    track = root.querySelector('[data-moje-scroll-spy-track]');
    nodesWrap = root.querySelector('[data-moje-scroll-spy-nodes]');
    desktopMq = window.matchMedia ? window.matchMedia(DESKTOP_MQ) : null;
    reduceMotion = prefersReducedMotion();
    bind();
    window.__mojeScrollSpyGoToY = function (y, smooth, opts) {
      goToY(y, smooth !== false, opts);
    };
    rebuild();
    window.setTimeout(rebuild, 400);
    window.setTimeout(rebuild, 1400);
    window.setTimeout(rebuild, 2800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
